import React from 'react';
import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useTranslation, useEnvironment } from '@wix/yoshi-flow-editor';
import { getFreeTrialDaysLabel } from '../../../../../utils';
import { st, classes } from './FreeTrial.st.css';

interface Props {
  plan: PublicPlan;
  freeTrialDaysExist: boolean;
  highlighted: boolean;
  className?: string;
}

export const FreeTrial: React.FC<Props> = ({ plan, freeTrialDaysExist, highlighted, className }) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  if (!freeTrialDaysExist) {
    return null;
  }

  return (
    <span
      data-hook={VIEWER_HOOKS.PLAN_FREE_TRIAL}
      className={st(classes.duration, { highlighted, mobile: isMobile }, className)}
    >
      {getFreeTrialDaysLabel(plan, t)}
    </span>
  );
};
